module.exports = __webpack_public_path__ + "img/FR30004.93e0eee0.png";